import React from 'react';
import { Query, withApollo } from "react-apollo";

import { clientCredentials } from '../../graphql/queries';

class CommentReply extends React.Component {

	render() {

		return (
			<Query query={clientCredentials}>
                {({ data: { clientCredentials }, client }) => (
                    <div className="card card--top">
                        <div className="card-media card-media--inline">
                            <div className="avatar" style={{backgroundImage: `url(/avatare/${clientCredentials.avatar})`}}></div>
                        </div>
                        <div className="card-content">
                            <textarea className="textarea textarea--inline"></textarea>
                        </div>
                    </div>
                )}
            </Query>
      	)
	}
}

export default withApollo(CommentReply)


// WEBPACK FOOTER //
// ./src/components/comment/CommentReply.js